import React from 'react'

import './geofenceItem.css';

const GeofenceItem = ({ geofence }) => {
    return (
        <div className='geofence_item'>
            <span className="material-symbols-rounded icon">my_location</span>
            <div>
                <span className='name'>{geofence.label}</span>
                <span className='tag'>Checadas</span>
            </div>
            <span className="material-symbols-rounded icon" title='Editar'>edit</span>
        </div>
    )
}

export default GeofenceItem